module.exports = __webpack_public_path__ + "static/media/referral.3a462a0f.svg";